import React from "react";
import Card from "components/card";

/**
 * Compact centered metric used inside question analytics (render inside a `<dl>`).
 * Pass `caption` for the numerator and denominator behind a percentage, e.g. "9 of 12 responses".
 */
const StatTile = ({ label, value, caption }) => (
  <Card padding="sm" className="text-center">
    <dt className="text-xs text-fg-muted">{label}</dt>
    <dd className="order-first text-2xl font-bold text-fg">{value}</dd>
    {caption && <dd className="mt-1 text-xs text-fg-muted">{caption}</dd>}
  </Card>
);

export default StatTile;
